import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { stripLocale } from "@/i18n/locale";

/**
 * Scrolls the window to the top whenever the route pathname changes.
 * Honors the user's reduced-motion preference and respects in-page hash anchors
 * (e.g. /products/#hubs) by NOT scrolling when a hash is present.
 */
export function ScrollToTop() {
  const { pathname: rawPathname, hash } = useLocation();
  // Language switches keep the visitor's scroll position.
  const pathname = stripLocale(rawPathname);

  useEffect(() => {
    if (hash) return;
    const prefersReduced =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: prefersReduced ? "auto" : "instant" as ScrollBehavior,
      });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
